import { ShieldCheck } from 'lucide-react';
import { Panel, Metric, Empty } from './Panel';

export const CredCard = ({ c, canOpen }) => (
  <Panel title="Credentialing status" subtitle={`${c.bcbas} BCBAs · ${c.payers} payers`} icon={ShieldCheck}
    to={canOpen ? '/vault' : null} linkLabel="Open vault" testid="ludo-dash-cred">
    <div className="grid grid-cols-3 gap-3 mb-5">
      <Metric label="Active" value={c.active} tone="text-[#3C6152]" testid="ludo-dash-cred-active" />
      <Metric label="Pending" value={c.pending} tone={c.pending ? 'text-[#B08A3A]' : undefined} testid="ludo-dash-cred-pending" />
      <Metric label="Not started" value={c.not_started} testid="ludo-dash-cred-not-started" />
    </div>
    {c.by_provider.length === 0 ? <Empty testid="ludo-dash-cred-empty">Add BCBAs in the Admin Vault roster to track credentialing.</Empty> : (
      <table className="w-full text-[12.5px] mb-4" data-testid="ludo-dash-cred-table">
        <thead><tr className="text-[10.5px] uppercase tracking-wider text-[#8A7B95]"><th className="text-left font-semibold pb-1">BCBA</th><th className="font-semibold">Active</th><th className="font-semibold">Pending</th><th className="font-semibold">To do</th></tr></thead>
        <tbody>
          {c.by_provider.map((r) => (
            <tr key={r.provider} className="border-t border-[#F1EDF5]">
              <td className="py-1.5 text-[#2D2833]">{r.provider}</td>
              <td className="text-center tabular-nums text-[#3C6152]">{r.active}</td>
              <td className="text-center tabular-nums text-[#B08A3A]">{r.pending}</td>
              <td className="text-center tabular-nums">{r.not_started}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
    <div className="text-[11px] uppercase tracking-[0.12em] text-[#8A7B95] font-semibold mb-2">Reviews due in 60 days</div>
    {c.expiring.length === 0 ? <Empty testid="ludo-dash-cred-expiring-empty">Nothing due soon.</Empty> : (
      <ul className="space-y-1" data-testid="ludo-dash-cred-expiring">
        {c.expiring.map((e, i) => (
          <li key={i} className="flex justify-between text-[12.5px]">
            <span>{e.provider} <span className="text-[#8A7B95]">· {e.payer}</span></span>
            <span className={`tabular-nums ${e.overdue ? 'text-[#8A3A3A] font-semibold' : 'text-[#6E5F78]'}`}>{e.date}</span>
          </li>
        ))}
      </ul>
    )}
  </Panel>
);

export default CredCard;
